import { useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import { FaCheck, FaRegUser } from 'react-icons/fa6';
import { RiTimeLine, RiGroupLine, RiShieldStarLine } from 'react-icons/ri';
import lazerImg from '../../../../assets/game-img/1.jpeg';
import gidraImg from '../../../../assets/game-img/2.jpg';
import peintImg from '../../../../assets/game-img/3.jpeg';
import skypark from '../../../../assets/game-img/1.jpg';
import style from './modal.module.css';
import classNames from 'classnames';

const gameInfo = {
  Лазертаг: {
    title: 'Что такое Лазертаг?',
    description:
      'это командная игра для детей и взрослых, сочетающая спорт и развлечение, в которой игроки стараются попасть в противников лазерным лучом, зарабатывая очки.',
    scenarios: [
      'Игра на выбивание',
      'Захват контрольной точки',
      'Захват флага',
      'Предатель',
    ],
    bg: lazerImg,
  },
  Гидробол: {
    title: 'Что такое Гидробол?',
    description:
      'это динамичная командная игра, в которой игроки используют оружие, стреляющее безопасными гидрогелевыми шариками, чтобы поразить противников.',
    scenarios: ['Игра на выбивание', 'Захват флага', 'Оборона'],
    bg: gidraImg,
  },
  Пейнтбол: {
    title: 'Что такое Пейнтбол?',
    description:
      'это игра для активных людей, которым приходится жестко контроллировать свои эмоции в повседневной жизни.',
    scenarios: [
      'Уничтожить врага (быстро и технично)',
      'Прикрывать своих',
      'Не высовываться!',
    ],
    bg: peintImg,
  },
  default: {
    title: 'Что такое Скайпарк?',
    description:
      'развлекательный комплекс с экстремальными аттракционами на высоте, такими как канатные дороги, зиплайны, подвесные мосты и тарзанки, которые дарят незабываемые эмоции.',
    scenarios: [],
    bg: skypark,
  },
};

const GamesModal = ({ dataType, modalAboutIsOpen, closeModal }) => {
  const currentGame = gameInfo[dataType?.Name] || gameInfo.default;

  useEffect(() => {
    const handleEsc = (e) => e.key === 'Escape' && closeModal();
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [closeModal]);

  const details = [
    { icon: <FaCheck />, text: 'Инструктаж' },
    dataType.Game_desc && { icon: <FaCheck />, text: dataType.Game_desc },
    dataType.Equipment && {
      icon: <RiShieldStarLine />,
      text: dataType.Equipment,
    },
    dataType.Time && {
      icon: <RiTimeLine />,
      text: `Длительность - ${dataType.Time}`,
    },
    dataType.Rest_time && {
      icon: <RiTimeLine />,
      text: `Зона отдыха - ${dataType.Rest_time}`,
    },
  ];

  const important = [
    dataType.MinGamers && {
      icon: <RiGroupLine />,
      text: `Мин. игроков - ${dataType.MinGamers}`,
    },
    dataType.Age && {
      icon: <FaRegUser />,
      text: `Мин. возраст - ${dataType.Age}`,
    },
  ];

  const additional = [
    dataType.Ext_time && { text: `Продление - ${dataType.Ext_time}` },
    dataType.Bols && { text: `Доп. шары - ${dataType.Bols}` },
    dataType.additional && { text: dataType.additional },
  ];

  return (
    <div
      className={classNames(style.modal, { [style.active]: modalAboutIsOpen })}
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target.classList.contains(style.modal)) closeModal();
      }}
    >
      <div className="container">
        <div className={style.box}>
          <div className={style.header}>
            <h2>
              {dataType.Name} {dataType.Arena_type}
            </h2>
            <span className={style.close} onClick={closeModal}>
              <MdClose className={style.icon} />
            </span>
          </div>

          <div className={style.content}>
            <div className={style.desc}>
              <h3>Цена</h3>
              <div className={style.price}>
                {dataType.Name === 'Скайпарк' ? (
                  <>
                    <span>{dataType.Price}</span>
                    <br />
                    <span>{dataType.doble_price}</span>
                  </>
                ) : (
                  <>
                    <b>{dataType.Price}</b>
                    <span>{dataType.Full_time}</span>
                  </>
                )}
              </div>

              <ul className={style.detal}>
                <span className={style.row}>В стоимость включено:</span>
                {details.filter(Boolean).map((item, i) => (
                  <li key={i}>
                    {item.icon} <span>{item.text}</span>
                  </li>
                ))}
                {important.some(Boolean) && (
                  <span className={style.row}>Важно:</span>
                )}
                {important.filter(Boolean).map((item, i) => (
                  <li key={i}>
                    {item.icon} <span>{item.text}</span>
                  </li>
                ))}
                {additional.some(Boolean) && (
                  <span className={style.row}>Дополнительно:</span>
                )}
                {additional.filter(Boolean).map((item, i) => (
                  <li key={i}>
                    <span>{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className={style.about}>
              <h3>{currentGame.title}</h3>
              <div
                className={style.game_contnet}
                style={{ backgroundImage: `url(${currentGame.bg})` }}
              >
                <div className={style.about_text}>
                  <span>
                    <b>{dataType.Name}</b> — {currentGame.description}
                  </span>
                  {currentGame.scenarios.length > 0 && (
                    <div className={style.about_desc}>
                      <span>Сценарии:</span>
                      <ul>
                        {currentGame.scenarios.map((scenario, i) => (
                          <li key={i}>- {scenario}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GamesModal;
